import { useRef, useState, useEffect } from "react";
import { Box, Typography, Paper } from "@mui/material";

import { dataURLtoFile, drawTextline } from "./utils";

export default function ServingExampleAppOCR(props) {
  let backend_url = process.env.REACT_APP_BACKEND_URL;

  const imgRef = useRef("img");
  const [paragraphs, setParagraphs] = useState([]);

  const inference = async (img) => {
    let data = new FormData();
    data.append("image", img);
    props.onChangeIsInferencing(true);
    const t = Date.now();
    const res = await fetch(`${backend_url}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Accept-Language": "en",
      },
      body: data,
    })
      .catch((err) => {
        props.onChangeMsg(`${err}`);
      })
      .finally(() => {
        props.onChangeIsInferencing(false);
      });
    let result = await res.json();
    props.onChangeTook(Date.now() - t);
    let cvImage = props.cv.imread("img");
    const paragraphs = drawTextline(
      props.cv,
      cvImage,
      imgRef.current.height,
      imgRef.current.width,
      imgRef.current.naturalHeight,
      imgRef.current.naturalWidth,
      result
    );
    setParagraphs(paragraphs);
    props.cv.imshow("canvas", cvImage);
    cvImage.delete();
  };

  useEffect(() => {
    if (!props.imgFile) {
      return;
    }

    inference(props.imgFile);
  }, [props.imgFile]);

  return (
    <>
      <Box sx={{ flex: 1 }} style={{ paddingTop: "10px" }} hidden>
        {props.img && (
          <img
            id="img"
            alt="Original input"
            src={props.img}
            ref={imgRef}
            style={{ width: "100%", objectFit: "contain" }}
          />
        )}
      </Box>
      <Box sx={{ flex: 1 }} style={{ paddingTop: "10px" }}>
        <canvas id="canvas" style={{ width: "100%", objectFit: "contain" }} />
      </Box>
      <Box
        sx={{ flex: 1 }}
        style={{ paddingTop: "20px", paddingBottom: "50px" }}
      >
        {paragraphs &&
          paragraphs.map((paragraph, idx) => (
            <Paper key={idx} elevation={3} style={{ padding: "5px" }}>
              <Typography>
                {paragraph["lines"]
                  .flatMap((line) => line["words"].flatMap((word) => word.data))
                  .join(" ")}
              </Typography>
            </Paper>
          ))}
      </Box>
    </>
  );
}
